import { getWorkerUrl } from '@/lib/requests/worker/common';
import { WORKERS } from '@/constants/routes';

export const enqueueUserRescan = async (accessToken: string) => {
    const workerUrl = getWorkerUrl(WORKERS.FileExtraction);
    return fetch(workerUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    });
};
